import TagManager from 'react-gtm-module';

const initializedIds = new Set();

export const initGTM = (gtmId) => {
  if (!gtmId || initializedIds.has(gtmId)) return;
  initializedIds.add(gtmId);
  TagManager.initialize({ gtmId });
};
